module.exports = __webpack_public_path__ + "img/simplepay-logo-cards.52241a7b.png";